import { render, staticRenderFns } from "./PelletsChartOverview.vue?vue&type=template&id=08712a43&scoped=true"
import script from "./PelletsChartOverview.vue?vue&type=script&lang=ts"
export * from "./PelletsChartOverview.vue?vue&type=script&lang=ts"
import style0 from "./PelletsChartOverview.vue?vue&type=style&index=0&id=08712a43&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08712a43",
  null
  
)

export default component.exports